import { ApiClient } from "@ucl/library";

export interface PlaidLinkTokenRequest {
  userId: string;
}

export interface PlaidLinkTokenResponse {
  linkToken: string;
  userId: string;
}

class PlaidIntegrationApiClient {
  private _apiClient: ApiClient;

  constructor(apiClient: ApiClient) {
    this._apiClient = apiClient;
  }

  getLinkToken = async (request: PlaidLinkTokenRequest) => {
    return this._apiClient.post<PlaidLinkTokenResponse>(
      `api/PlaidIntegration/identity-verification/start`,
      request
    );
  };
}

export default PlaidIntegrationApiClient;
